import type { SVGProps } from "react";

export function IconDarkPurpleListPerson(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.375 9.625H1.375M9.625 16.5H1.375M9.625 23.375H1.375M28.875 8.9375C28.875 11.5954 26.7204 13.75 24.0625 13.75C21.4046 13.75 19.25 11.5954 19.25 8.9375C19.25 6.27963 21.4046 4.125 24.0625 4.125C26.7204 4.125 28.875 6.27963 28.875 8.9375ZM16.5 27.5V19.25H31.625V27.5H16.5Z"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
